//User
export const GET_ALL = 'GET_ALL';
export const GET = 'GET';
export const ADD = 'ADD';

//Unit
export const GET_ALL_UNIT = 'GET_ALL_UNIT';
export const GET_UNIT = 'GET_UNIT';
